namespace TabAurous.OMS {
    export interface GiftVoucherDetailsRow {
        GvDetailId?: number;
        GvId?: number;
        ProductApplicable?: number;
    }

    export namespace GiftVoucherDetailsRow {
        export const idProperty = 'GvDetailId';
        export const localTextPrefix = 'OMS.GiftVoucherDetails';
        export const deletePermission = 'Masters:GiftVoucher:Delete';
        export const insertPermission = 'Masters:GiftVoucher:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:GiftVoucher:Edit';

        export declare const enum Fields {
            GvDetailId = "GvDetailId",
            GvId = "GvId",
            ProductApplicable = "ProductApplicable"
        }
    }
}
